import debounce from 'lodash/debounce';

class AudioPlayer {
  constructor() {
    this.debounceSetPause = debounce(this.setPause, 100);

    this.stopQueue = new Map(); // audioUrl, callback()

    this.audioElement = document.createElement('audio');
    this.audioElement.addEventListener('play', this.setPlaying);
    this.audioElement.addEventListener('pause', this.debounceSetPause);
    this.audioElement.addEventListener('ended', this.debounceSetPause);
  }

  setPlaying = () => {
    this.playing = true;
  };

  setPause = () => {
    this.playing = false;
    this.emitStopFunc();
  };

  /**
   * @public
   * @param audioUri
   */
  play = (audioUri) => {
    // 全部触发一次暂停
    this.emitStopFunc(audioUri);
    this.audioElement.src = audioUri;
    this.audioElement.addEventListener('loadedmetadata', this.handleLoadedMetaData);
  };

  /**
   * @public
   */
  stop = () => {
    this.audioElement.pause();
  };

  handleLoadedMetaData = () => {
    this.audioElement.removeEventListener('loadedmetadata', this.handleLoadedMetaData);
    // noinspection JSIgnoredPromiseFromCall
    this.audioElement.play();
  };

  // noinspection JSUnusedGlobalSymbols
  getIsPlaying = () => this.playing;

  registerStopListener(audioUri, callback) {
    this.stopQueue.set(audioUri, callback);
  }

  offStop(audioUri) {
    this.stopQueue.delete(audioUri);
  }

  emitStopFunc(excludeUri) {
    this.stopQueue.forEach((func, audioUri) => {
      if (typeof func === 'function' && audioUri !== excludeUri) {
        func();
      }
    });
  }
}

export default new AudioPlayer();
